import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-3 0 49 29"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("path", { d: "M1.67.711 28.587.673 13 23.469h6.582s7.042 5.13 8.088 5.41H.792l15.55-22.643H1.67V.71z" }),
      _createElementVNode("path", { d: "m27.217 4.61 15.701 10.926-3.477 4.97-1.955-1.378s1.226 4.232-2.257 7.907c-1.765 1.505-2.791 1.957-5.156 1.786-1.923-.36-3.26-1.32-4.008-1.786-.75-.467-9.93-6.808-9.93-6.808l3.604-4.938s8.305 5.793 9.627 6.692c.985.639 2.235 1.07 3.13.824 1.241-.41 2.969-2.67 1.2-6.25C26.965 11.93 23.64 9.693 23.64 9.693z" })
    ], -1)
  ])))
}
export default { render: render }